export const catches = [
  {
    id: "catch-1",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/ac44252f72a5aabf0ede538f2eaf8251.jpeg",
    alt: "大きな真鯛を抱えるアングラー",
    fish: "真鯛",
    size: "89cm",
    weight: "3.2kg",
    location: "島根県松江市",
    lure: "雷撃カゴ０２ YELLOW",
    method: "磯カゴ釣り",
    label: "CATCH",
    objectPosition: "50% 25%",
  },
  {
    id: "catch-2",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/514bfc473bcd8f221048e3f2f5fd38b1.jpeg",
    alt: "磯で大きな真鯛を手にするアングラー",
    fish: "真鯛",
    size: "80cm",
    weight: "2.1kg",
    location: "島根県隠岐郡",
    lure: "雷撃カンツキウキ PINK",
    method: "磯カゴ釣り",
    label: "CATCH",
    objectPosition: "50% 25%",
  },
  {
    id: "catch-3",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/c13a9f0255435e7a0ed672e3b167b4af.png",
    alt: "ヒラマサと根魚、複数の釣果と雷撃カゴ",
    fish: "ヒラマサ・グレ他",
    size: "複数尾",
    weight: "-",
    location: "島根県松江市",
    lure: "雷撃カゴ０２ ORANGE",
    method: "磯カゴ釣り",
    label: "CATCH",
    objectPosition: "50% 60%",
  },
  {
    id: "catch-4",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/473803dc64cca998b8746c49a8673b97.jpeg",
    alt: "網の上に乗せられた大きな真鯛と雷撃カゴ",
    fish: "真鯛",
    size: "75cm",
    weight: "2.8kg",
    location: "島根県隠岐郡",
    lure: "雷撃カゴ０３ ORANGE",
    method: "磯カゴ釣り",
    label: "CATCH",
    objectPosition: "50% 30%",
  },
  {
    id: "catch-5",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/1d82d4b312cd938ab95a1781e7fb7ea8.jpeg",
    alt: "岩場に並んだイサキ・サバと雷撃カゴ",
    fish: "イサキ・サバ他",
    size: "30cm",
    weight: "-",
    location: "松江市地磯",
    lure: "雷撃カゴ０２ PINK",
    method: "磯カゴ釣り",
    label: "CATCH",
    objectPosition: "50% 50%",
  },
  {
    id: "catch-6",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/17489499d8028ae24bc384e08bc865ad.jpeg",
    alt: "クーラーに入ったヒラマサ・イサキの釣果",
    fish: "ヒラマサ・イサキ他",
    size: "60cm",
    weight: "-",
    location: "出雲市沖磯",
    lure: "雷撃カゴ０２ YELLOW",
    method: "磯カゴ釣り",
    label: "CATCH",
    objectPosition: "50% 55%",
  },
];